import Button from 'Components/Base/Button'
import Icon from 'Components/Base/Icon'
import Row from 'Components/Base/Row'
import Typography from 'Components/Base/Typography'
import React, { useEffect, useState } from 'react'
import styled, { useTheme } from 'styled-components'

interface props {
  header: string
  bestFor: string
  details: string[]
  handleSelectProgram: Function
  ctl: boolean
}

export default function PathCard({ header, bestFor, details, handleSelectProgram, ctl }: props) {
  const theme = useTheme()
  const [isMobile, setIsMobile] = useState<boolean>(false)

  const setMobileSetting = () => {
    if (window.innerWidth < 800) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }

  useEffect(() => {
    setMobileSetting()
    window.addEventListener('resize', () => {
      setMobileSetting()
    })
  }, [])

  return (
    <Card>
      <Header>{header}</Header>
      <BestFor>
        <b>Best for: </b>
        {bestFor}
      </BestFor>
      <Button text="Start Here" styles={{ width: '100%', fontWeight: 'bold' }} onClick={() => handleSelectProgram(ctl ? 1 : 0)} />
      {details.map((detail) => (
        <Row styles={{ marginTop: 15 }}>
          <Icon name="circleCheck" color={theme.colors.primary1} styles={{ marginTop: 'auto', marginBottom: 'auto', marginRight: 10 }} />
          <Typography size={16} styles={{ lineHeight: '117%' }}>
            {detail}
          </Typography>
        </Row>
      ))}
    </Card>
  )
}

const Card = styled.div`
  border-radius: 34px;
  max-width: 499px;
  border: 1px solid #bdbdbd;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
  font-family: Raleway;
  max-width: 400px;
  padding: 30px;
  text-align: left;
  @media only screen and (max-width: 600px) {
    margin-top: 20px;
  }
`

const Header = styled.h1`
  font-family: Raleway-Bold;
  font-weight: 1000;
  font-size: 28px;
  padding-right: 60px;
  margin-bottom: 20px;
`

const BestFor = styled.p`
  font-size: 16px;
  margin-bottom: 20px;
`
